/*
  GoRoam video block: swaps the poster for the real player only when someone presses play.
  Works for YouTube (nocookie embed) and Instagram (post embed). Keyboard: the poster is a button.
*/
document.querySelectorAll('[data-gr-video]').forEach((box) => {
  if (box.dataset.ready) return;
  box.dataset.ready = '1';
  const btn = box.querySelector('.grh-video__poster');
  btn?.addEventListener('click', () => {
    const f = document.createElement('iframe');
    f.src = box.dataset.src;
    f.title = box.dataset.title || 'Video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    f.allowFullscreen = true;
    f.loading = 'eager';
    f.setAttribute('frameborder', '0');
    box.classList.add('is-playing');
    box.replaceChild(f, btn);
    f.focus();
  });
});
